import { connect } from 'react-redux';
import { selectWaitingHallUpdate } from '%paysera_seat_selection_integration/js/seatings/redux';
import HallSpinner from './HallSpinner';

export default connect(
    state => ({
        loading: selectWaitingHallUpdate(state),
    }),
)(HallSpinner);
